import { api } from "@/lib/api"

export function useIsCartageTeamMember(): boolean {
    const { data: user } = api.user.getMyUser.useQuery()
    return user?.isCartageTeamMember ?? false
}
